import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { integrationsRouter } from './routing/integrationsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { integrationsSquareAccessControl } from './access-control/squareIntegration.configuration'
import { integrationsAccessControl } from './access-control/integrationsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'integrations',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'integrations-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
  },
  routers: {
    scoped: [integrationsRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Settings,
      attachToV2: NavEntryPoint.UserMenuSettings,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage and configure third-party integrations',
          labelId: 'integrationsDomain.title',
          route: 'integrations-list',
          accessControl: integrationsAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
